export const PIN_FORGOT_STATE_RESET = 'PIN_FORGOT_STATE_RESET';
export const PIN_RESET_STATE_RESET = 'PIN_RESET_STATE_RESET';
export const PIN_OPEN_FORGOT_PIN_MODAL = 'PIN_OPEN_FORGOT_PIN_MODAL';
export const PIN_CLOSE_FORGOT_PIN_MODAL = 'PIN_CLOSE_FORGOT_PIN_MODAL';

export function pinForgotStateReset() {
  return {
    type: PIN_FORGOT_STATE_RESET
  };
}

export function pinResetStateReset() {
  return {
    type: PIN_RESET_STATE_RESET
  };
}

export function openForgotPinModal() {
  return {
    type: PIN_OPEN_FORGOT_PIN_MODAL
  };
}

export function closeForgotPinModal() {
  return {
    type: PIN_CLOSE_FORGOT_PIN_MODAL
  };
}



// WEBPACK FOOTER //
// ./src/actions/pin.js